export default "__VITE_ASSET__Bbzy1zEY__"